(function () {
  'use strict';

  var STORAGE_KEY = 'yorozuya_cookie_consent';
  var CONSENT_VERSION = '1';

  function getConsent() {
    var prefix = STORAGE_KEY + '=';

    try {
      var cookie = document.cookie.split(';').map(function (entry) {
        return entry.trim();
      }).find(function (entry) {
        return entry.indexOf(prefix) === 0;
      });
      if (cookie) {
        var cookieData = JSON.parse(decodeURIComponent(cookie.slice(prefix.length)));
        if (cookieData && cookieData.version === CONSENT_VERSION && cookieData.consent) {
          return cookieData;
        }
      }
    } catch (e) {
      return null;
    }

    try {
      var legacyData = JSON.parse(localStorage.getItem(STORAGE_KEY));
      if (legacyData && legacyData.version === CONSENT_VERSION && legacyData.consent) {
        setConsent(legacyData.consent);
        return legacyData;
      }
    } catch (e) {
      return null;
    }

    return null;
  }

  function setConsent(consent) {
    try {
      var data = JSON.stringify({
        version: CONSENT_VERSION,
        consent: consent,
        timestamp: new Date().toISOString(),
      });
      var attributes = 'Max-Age=31536000; Path=/; SameSite=Lax';
      if (window.location.protocol === 'https:') {
        attributes += '; Secure';
      }
      document.cookie = STORAGE_KEY + '=' + encodeURIComponent(data) + '; ' + attributes;
    } catch (e) {
      return;
    }
  }

  function getDefaultConsent() {
    return {
      necessary: true,
      analytics: false,
      marketing: false,
    };
  }

  function applyShopifyTrackingConsent(consent) {
    var trackingConsent = {
      analytics: Boolean(consent.analytics),
      marketing: Boolean(consent.marketing),
      preferences: false,
      sale_of_data: Boolean(consent.marketing),
    };

    if (
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function'
    ) {
      window.Shopify.customerPrivacy.setTrackingConsent(trackingConsent);
    }
  }

  function applyScriptBlocking(consent) {
    var scripts = document.querySelectorAll('script[data-cookie-consent]');
    scripts.forEach(function (script) {
      var category = script.getAttribute('data-cookie-consent');
      if (consent[category]) {
        enableScript(script);
      }
    });
  }

  function enableScript(script) {
    if (script.dataset.enabled === 'true') return;

    var newScript = document.createElement('script');
    if (script.src) {
      newScript.src = script.src;
    } else {
      newScript.textContent = script.textContent;
    }

    Array.prototype.forEach.call(script.attributes, function (attr) {
      if (attr.name !== 'data-cookie-consent' && attr.name !== 'type') {
        newScript.setAttribute(attr.name, attr.value);
      }
    });

    newScript.type = 'text/javascript';
    newScript.dataset.enabled = 'true';

    script.parentNode.insertBefore(newScript, script);
    script.parentNode.removeChild(script);
  }

  function dispatchConsentEvent(consent) {
    document.dispatchEvent(
      new CustomEvent('cookieConsentUpdated', {
        detail: consent,
      })
    );
  }

  function init() {
    var banner = document.getElementById('CookieConsentBanner');
    if (!banner) return;

    var consent = getConsent();
    var currentConsent = consent ? consent.consent : null;

    if (currentConsent) {
      applyShopifyTrackingConsent(currentConsent);
      applyScriptBlocking(currentConsent);
      dispatchConsentEvent(currentConsent);
      return;
    }

    var defaultConsent = getDefaultConsent();
    applyShopifyTrackingConsent(defaultConsent);
    applyScriptBlocking(defaultConsent);

    var acceptAllButton = document.getElementById('CookieConsentAcceptAll');
    var rejectAllButton = document.getElementById('CookieConsentRejectAll');
    var customizeButton = document.getElementById('CookieConsentCustomize');
    var savePreferencesButton = document.getElementById('CookieConsentSavePreferences');
    var preferencesPanel = document.getElementById('CookieConsentPreferences');
    var analyticsToggle = document.getElementById('CookieConsentAnalytics');
    var marketingToggle = document.getElementById('CookieConsentMarketing');

    function hideBanner() {
      banner.hidden = true;
      banner.style.display = 'none';
      banner.classList.remove('is-visible');
    }

    function showBanner() {
      banner.style.display = '';
      banner.hidden = false;
      // Force reflow
      void banner.offsetWidth;
      banner.classList.add('is-visible');
    }

    function saveAndApply(newConsent) {
      setConsent(newConsent);
      applyShopifyTrackingConsent(newConsent);
      applyScriptBlocking(newConsent);
      dispatchConsentEvent(newConsent);
      hideBanner();
    }

    if (acceptAllButton) {
      acceptAllButton.addEventListener('click', function () {
        saveAndApply({ necessary: true, analytics: true, marketing: true });
      });
    }

    if (rejectAllButton) {
      rejectAllButton.addEventListener('click', function () {
        saveAndApply({ necessary: true, analytics: false, marketing: false });
      });
    }

    if (customizeButton && preferencesPanel) {
      customizeButton.addEventListener('click', function () {
        preferencesPanel.classList.toggle('is-open');
      });
    }

    document.querySelectorAll('[data-open-cookie-preferences]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        showBanner();
        if (preferencesPanel) {
          preferencesPanel.classList.add('is-open');
        }
      });
    });

    if (savePreferencesButton && analyticsToggle && marketingToggle) {
      savePreferencesButton.addEventListener('click', function () {
        saveAndApply({
          necessary: true,
          analytics: analyticsToggle.checked,
          marketing: marketingToggle.checked,
        });
      });
    }

    // Show banner after a short delay
    setTimeout(function () {
      showBanner();
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
